import React from "react";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import firebase from "firebase/app";
import { FontIcon, Button } from "react-md";
// import { TextField, CardActions } from "react-md";

import "../styles/Login.css";

export default class Auth extends React.Component {
  constructor() {
    super();
    this.state = {
      isSignedIn: false,
      userInfo: "",
      email: "",
      password: "",
      error: ""
    };
    // Configure FirebaseUI
    this.uiConfig = {
      // Popup signin flow rather than redirect flow.
      signInFlow: "redirect",
      // We will display Google and Email as auth providers.
      signInOptions: [
        // List of OAuth providers supported.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ],
      callbacks: {
        signInSuccess: (currentUser, credential, redirectUrl) => {
          window.location.assign(`/account-settings`);
          return false;
        }
      }
    };
  }

  componentDidMount = () => {
    firebase.auth().onAuthStateChanged(user => {
      this.setState({ isSignedIn: !!user, userInfo: user });
      // IF FIRST TIME LOGIN IN CREATE A NEW USER OBJECT AT /storage/users/{userId}
      // ELSE SKIP TO DASHBOARD PAGES
    });
  };

  handleForm = e => {
    e.preventDefault();
    firebase
      .auth()
      .signInWithEmailAndPassword(this.state.email, this.state.password)
      .then(res => {
        if (res.user)
          this.setState({ isSignedIn: !!res.user, userInfo: res.user });
      })
      .catch(e => {
        this.setState({ error: e.message });
        console.log(e.message);
      });
  };

  render() {
    return (
      <div className="login_container">
        <div className="div-logo-center">
          <img className="logo" src={"./version04_blue.png"} alt="logo" height="200" />
        </div>
        {this.state.isSignedIn ? (
          <span>
            <Button
              onClick={() => firebase.auth().signOut()}
              primary
              raised
              iconEl={<FontIcon>exit_to_app</FontIcon>}
            >
              Sign Out!
            </Button>
            <div style={{ paddingTop: "10px" }}>
              Welcome{" "}
              {this.state.userInfo.displayName
                ? this.state.userInfo.displayName
                : "!"}
            </div>
            <div style={{ paddingTop: "3px", fontStyle: "oblique" }}>
              We are getting your account ready, you will receive an email from
              us when your account has been activated.
            </div>
          </span>
        ) : (
          <div
            style={{
              display: "block",
              margin: "auto"
            }}
          >
            {/* 
            // TODO: New Login flow using textfield for email and password
            <form onSubmit={e => this.handleForm(e)}>
              <TextField
                type={"email"}
                label="Email"
                name="email"
                className=""
                required
                onChange={val => this.setState({ email: val })}
                value={this.state.email}
              />
              <TextField
                secondary
                type={"password"}
                label="Password"
                name="password"
                className=""
                required
                onChange={val => this.setState({ password: val })}
                value={this.state.password}
              />
              <Button
                style={{display: 'block', margin: '20px auto 0px auto'}}
                raised
                primary
                type="submit"
                disabled={this.state.isDisabled}
              >
                Login
              </Button>
              <p style={{ color: "red" }}>{this.state.error}</p>
              <CardActions className="md-divider-border md-divider-border--bottom"/>
            </form> */}
            <StyledFirebaseAuth
              uiConfig={this.uiConfig}
              firebaseAuth={firebase.auth()}
            />
          </div>
        )}
      </div>
    );
  }
}
